import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const DBNCategoryBasicInfoComponent = ({
    handleInnerFormChange, selectedDbnDomain, selectedDbnCategory, domains, categories
}: any) => {

    console.log('selectedDbnCategory',selectedDbnCategory)
    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Name"
                            isDisabled={true}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Name'
                                )
                            }}
                            type="text"
                            value={selectedDbnCategory?.Name}
                        />
                        <InputContainer
                            label="Is Subcategory"
                            name="IsSubCategory"
                            isDisabled={true}

                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsSubCategory'
                                )                                
                            }}
                            type="checkbox"
                            value={selectedDbnCategory?.IsSubCategory}
                            />
                        {selectedDbnCategory?.IsSubCategory ? <InputContainer
                            label="Parent Category"
                            labelField="Name"
                            isDisabled={true}

                            list={categories}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ParentCategoryId'
                                );
                            }}
                            optionName='Choose Parent Category'
                            type="select"
                            value={selectedDbnCategory?.ParentCategoryId}
                            valueField="DBNCategoryId"
                        />: <></>}

                        <InputContainer
                            label="Code"
                            isDisabled={true}

                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Code'
                                )
                            }}
                            type="text"
                            value={selectedDbnCategory?.Code}
                        />
                        <InputContainer
                            label="Domain"
                            labelField="Name"
                            isDisabled={true}

                            list={domains}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DBNDomainId'
                                );
                            }}
                            optionName='Choose Domain'
                            type="select"
                            value={selectedDbnCategory?.DBNDomainId}
                            valueField="EdgeDBNDomainId"
                        />
                    </div>
                }
                expandedPanel="basicInfo"
                headerTitle="Category Information"
            />
        </>
    )
}

export default DBNCategoryBasicInfoComponent;
